import Icon from '@material-ui/core/Icon';
import { useState } from 'react';

/**
 * Banner de download do FT App.
 * Exibido na ficha do cliente para o consultor compartilhar o app facilmente.
 *
 * Env vars (opcional):
 *   REACT_APP_IOS_DOWNLOAD_URL   — link da App Store / TestFlight
 *   REACT_APP_ANDROID_DOWNLOAD_URL — link do Google Play
 */

const IOS_URL     = process.env.REACT_APP_IOS_DOWNLOAD_URL     || '#';
const ANDROID_URL = process.env.REACT_APP_ANDROID_DOWNLOAD_URL || '#';

export default function AppDownloadBanner({ customerEmail }) {
  const [copied, setCopied] = useState(false);

  const shareLink = IOS_URL !== '#' ? IOS_URL : ANDROID_URL;

  const handleCopy = () => {
    const text = customerEmail
      ? `Olá! Baixe o FT App para acompanhar suas reservas e passeios com a Full Tour:\n\niOS: ${IOS_URL}\nAndroid: ${ANDROID_URL}`
      : `Baixe o FT App:\n\niOS: ${IOS_URL}\nAndroid: ${ANDROID_URL}`;
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2500);
    });
  };

  return (
    <div
      style={{
        background: 'linear-gradient(135deg, #0f2340 0%, #1a3a5c 100%)',
        borderRadius: 10,
        padding: '20px 24px',
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 20,
        border: '1px solid #234d7a',
      }}
    >
      {/* Ícone + texto */}
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, flex: 1, minWidth: 220 }}>
        <div
          style={{
            width: 52,
            height: 52,
            borderRadius: 14,
            background: process.env.REACT_APP_PRIMARY_COLOR || '#62DEC2',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}
        >
          <Icon style={{ color: '#0f2340', fontSize: 28 }}>phone_iphone</Icon>
        </div>
        <div>
          <div style={{ color: '#fff', fontWeight: 600, fontSize: 15, fontFamily: 'Poppins' }}>
            FT App — Full Tour
          </div>
          <div style={{ color: '#a0b8cc', fontSize: 12, fontFamily: 'Poppins', marginTop: 2 }}>
            Disponível para iOS e Android
          </div>
        </div>
      </div>

      {/* Botões de download */}
      <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
        <StoreButton
          icon="apple"
          label="App Store"
          href={IOS_URL}
          primaryColor={process.env.REACT_APP_PRIMARY_COLOR || '#62DEC2'}
        />
        <StoreButton
          icon="android"
          label="Google Play"
          href={ANDROID_URL}
          primaryColor={process.env.REACT_APP_PRIMARY_COLOR || '#62DEC2'}
        />
        <button
          onClick={handleCopy}
          title="Copiar mensagem com links para enviar ao cliente"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6,
            padding: '8px 14px',
            borderRadius: 8,
            border: '1px solid #234d7a',
            background: copied ? '#1a4a2e' : 'transparent',
            color: copied ? '#4caf50' : '#a0b8cc',
            cursor: 'pointer',
            fontSize: 13,
            fontFamily: 'Poppins',
            transition: 'all 0.2s',
            whiteSpace: 'nowrap',
          }}
        >
          <Icon style={{ fontSize: 16 }}>{copied ? 'check' : 'content_copy'}</Icon>
          {copied ? 'Copiado!' : 'Copiar link'}
        </button>
      </div>
    </div>
  );
}

function StoreButton({ icon, label, href, primaryColor }) {
  const disabled = href === '#';
  return (
    <a
      href={disabled ? undefined : href}
      target={disabled ? undefined : '_blank'}
      rel="noreferrer"
      title={disabled ? 'Link ainda não configurado' : `Baixar na ${label}`}
      onClick={disabled ? (e) => e.preventDefault() : undefined}
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 7,
        padding: '8px 14px',
        borderRadius: 8,
        border: `1px solid ${disabled ? '#234d7a' : primaryColor}`,
        background: disabled ? 'transparent' : primaryColor + '18',
        color: disabled ? '#4a6a84' : primaryColor,
        textDecoration: 'none',
        fontSize: 13,
        fontFamily: 'Poppins',
        fontWeight: 500,
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
        whiteSpace: 'nowrap',
      }}
    >
      <Icon style={{ fontSize: 17 }}>{icon === 'apple' ? 'phone_iphone' : 'phone_android'}</Icon>
      {label}
    </a>
  );
}
